import { Clipboard } from '@capacitor/clipboard';
import { Capacitor } from '@capacitor/core';

export async function copyText(text: string): Promise<void> {
  if (Capacitor.isNativePlatform()) {
    await Clipboard.write({ string: text });
    return;
  }
  if (navigator.clipboard) {
    await navigator.clipboard.writeText(text);
  }
}
